<div class="mibi-page">
  <mibi-app-bar-top class="mibi-page__header"></mibi-app-bar-top>
  <mibi-page-body-container class="mibi-page__body"></mibi-page-body-container>
  <mibi-page-footer class="mibi-page__footer"></mibi-page-footer>
</div>